<template>
    <v-app>
        <v-app-bar app>
            <img style="height: 1.4em;" src="https://img.icons8.com/material/96/000000/radio-tower.png">
            <v-toolbar-title class="headline text-uppercase">
                <span>RADIO</span>
                <span class="font-weight-light">KOLLEN</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                text
                href="https://github.com/vuetifyjs/vuetify/releases/latest"
                target="_blank"
                disabled
            >
                <span class="mr-2 hidden-sm-and-down">Oberoende Granskning</span>
            </v-btn>
            <v-btn
                text
                to="/about"
                v-show="this.$route.path == '/' || this.$route.path =='/home'"
            >
                <span class="mr-2 hidden-sm-and-down">Hur jag räknat</span>
            </v-btn>
            <v-btn
                text
                to="/"
                v-show="this.$route.path == '/about'"
            >
                <span class="m-2 hidden-sm-and-down">Till statistiken</span>
            </v-btn>
        </v-app-bar>

        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: "App",
    components: {
    },
    data: () => ({
    })
};
</script>
